import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface FormFieldProps {
  id: string;
  label: string;
  error?: string;
  hint?: string;
  children: ReactNode;
  className?: string;
}

/** Label + control + error text. Every Sheet form is built out of these, so spacing stays uniform. */
export const FormField = ({ id, label, error, hint, children, className }: FormFieldProps) => (
  <div className={cn('space-y-1.5', className)}>
    <label
      htmlFor={id}
      className="block text-sm font-medium text-card-foreground"
    >
      {label}
    </label>
    {children}
    {error ? <p className="text-xs text-destructive">{error}</p> : hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
  </div>
);

export interface FormSectionProps {
  title: string;
  children: ReactNode;
}

/** A titled group of fields inside a Sheet. */
export const FormSection = ({ title, children }: FormSectionProps) => (
  <section className="space-y-3">
    <h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{title}</h3>
    {children}
  </section>
);
